export const getActiveViewName = activePath => activePath.split('/')[1];

export const getCheckedItem = list => {
  return list.find(el => el.checked);
};
